<template>
    <html data-wf-page="5b17a0c3e17ccd5653bd4f4e" data-wf-site="5b1755d5269b9c5142d82ca3">
<head>
  <meta charset="utf-8">
  <title>Cabinet Manager | Dashboard</title>
  <meta content="Cabinet Manager | Dashboard" property="og:title">
  <meta content="width=device-width, initial-scale=1" name="viewport">
  <link href="../static/css/exceptions.css" rel="stylesheet" type="text/css">
</head>
<body class="body-2">
  <MobileNav :project="project" :current-page="'settings'"></MobileNav>
  <div class="wholewrapper">
    <div class="div-block-24">
      <NavSideBar :current-page="'settings'" :project="project"></NavSideBar>
      <div class="contentcontainer">
        <div class="contenttop">
          <div class="div-block-30">
            <div class="projectselector">
              <el-dropdown trigger="click" @command="switchProject">
                <span class="el-dropdown-link" style="color: #fff; font-weight: bold;">{{ project.name }}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="project in projectList"
                    v-if="project.status !== 'closed'"
                    :key="project.id"
                    :command="project.id">{{ project.name }}
                  </el-dropdown-item>
                  <el-dropdown-item divided
                    :command="''">All Projects
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <SignInButton :user="user" @login="$emit('login')"></SignInButton>
          </div>
          <div class="div-block-32">
            <div class="text-block-16">Project Setting</div>
          </div>
        </div>
        <div class="contentdown">
          <div class="downcontentdrawings">
            <div class="section-title"> Project Info </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Project Name &nbsp; &nbsp;</span> {{ project.name }}
                <i v-show="editingField !== 'name'" @click="startEdit('name')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'name'" v-model="editingValue" placeholder="Please input new value" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center; word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Project ID &nbsp; &nbsp;</span> {{ project.id }}
                <el-tooltip effect="dark" content="Project ID is unchangeable." placement="right">
                  <i class="el-icon-info item-tip"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="section-item"><div style="width:100%;display:flex;align-items:center;"> <span style="color: #999; font-size: 0.9em">Created On &nbsp; &nbsp;</span> {{ project.create_date }}</div></div>
            <div class="section-title"> Project Manager </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Name &nbsp; &nbsp;</span> {{ project.manager ? project.manager.name : 'Not set' }}
                <i v-show="editingField !== 'manager.name'" @click="startEdit('manager.name')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'manager.name'" v-model="editingValue" placeholder="Please input new name" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Email &nbsp; &nbsp;</span> {{ project.manager ? project.manager.email : 'Manager not set' }}
                <i v-show="editingField !== 'manager.email'" @click="startEdit('manager.email')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'manager.email'" v-model="editingValue" type="email" placeholder="Please input new email" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Phone &nbsp; &nbsp;</span> {{ project.manager ? project.manager.phone : 'Manager not set' }}
                <i v-show="editingField !== 'manager.phone'" @click="startEdit('manager.phone')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'manager.phone'" v-model="editingValue" type="tel" placeholder="Please input new phone" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-title"> Superintendent </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Name &nbsp; &nbsp;</span> {{ project.superintendent ? project.superintendent.name : 'Not set' }}
                <i v-show="editingField !== 'superintendent.name'" @click="startEdit('superintendent.name')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'superintendent.name'" v-model="editingValue" placeholder="Please input new name" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Email &nbsp; &nbsp;</span> {{ project.superintendent ? project.superintendent.email : 'Superintendent not set' }}
                <i v-show="editingField !== 'superintendent.email'" @click="startEdit('superintendent.email')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'superintendent.email'" v-model="editingValue" type="email" placeholder="Please input new email" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Phone &nbsp; &nbsp;</span> {{ project.superintendent ? project.superintendent.phone : 'Superintendent not set' }}
                <i v-show="editingField !== 'superintendent.phone'" @click="startEdit('superintendent.phone')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'superintendent.phone'" v-model="editingValue" type="tel" placeholder="Please input new phone" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
          </div>
          <div class="downcontentdrawings">
            <div class="section-title"> Client Info </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center; word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Client Name &nbsp; &nbsp;</span> {{ project.client }}
                <i v-show="editingField !== 'client'" @click="startEdit('client')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'client'" v-model="editingValue" placeholder="Please input new value" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center; word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Client Address &nbsp; &nbsp;</span> {{ project.address }}
                <i v-show="editingField !== 'address'" @click="startEdit('address')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'address'" v-model="editingValue" placeholder="Please input new value" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center; word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Contact Info &nbsp; &nbsp;</span> {{ project.contact }}
                <i v-show="editingField !== 'contact'" @click="startEdit('contact')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'contact'" v-model="editingValue" placeholder="Please input new value" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-title"> Delivery </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Address &nbsp; &nbsp;</span> {{ project.delivery ? project.delivery.address : 'Not set' }}
                <i v-show="editingField !== 'delivery.address'" @click="startEdit('delivery.address')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'delivery.address'" v-model="editingValue" placeholder="Please input new address" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Email &nbsp; &nbsp;</span> {{ project.delivery ? project.delivery.email : 'Not set' }}
                <i v-show="editingField !== 'delivery.email'" @click="startEdit('delivery.email')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'delivery.email'" v-model="editingValue" type="email" placeholder="Please input new email" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
            <div class="section-item">
              <div style="width:100%;display:flex;align-items:center;word-break: break-all;">
                <span style="color: #999; font-size: 0.9em; word-break: normal;">Phone &nbsp; &nbsp;</span> {{ project.delivery ? project.delivery.phone : 'Not set' }}
                <i v-show="editingField !== 'delivery.phone'" @click="startEdit('delivery.phone')" class="el-icon-edit" style="color: #00838f; font-size: 24px;margin: 12px;"></i>
              </div>
              <el-input v-show="editingField === 'delivery.phone'" v-model="editingValue" type="tel" placeholder="Please input new phone" style="margin: 16px 0 16px;">
                <el-button slot="append" icon="el-icon-check" @click="confirmEdit" style="color: #00838f"></el-button>
                <el-button slot="append" icon="el-icon-close" @click="cancelEdit" style="color: #f56c6c"></el-button>
              </el-input>
            </div>
          </div>
          <div class="downcontentdrawings">
            <div class="danger-title"> Shutdown Project </div>
            <div class="danger-tag">
              <i class="el-icon-warning"></i>
              <strong>Warning: &nbsp;</strong> If you shutdown a project, it means:
              <ul>
                <li style="margin: 12px;">This project will never show in the project list.</li>
                <li style="margin: 12px;">All the data of this project will never be changed.</li>
                <li style="margin: 12px;">The ID of this project will be occupied permanently and cannot be used by other project.</li>
              </ul>
              If you are ready, input <strong>'UNLOCK'</strong> in the box below to unlock the shutdown button.
              <el-input v-model="unlockInput" style="margin-top: 16px;"></el-input>
            </div>
            <el-button type="danger" @click="shutdownProject" style="margin-top: 16px; width: 100%;" :disabled="unlockInput !== 'UNLOCK'"><div style="display:flex;align-items:center;justify-content:center"><i class="material-icons" style="margin-right:8px;">{{ unlockInput === 'UNLOCK' ? 'lock_open' : 'lock'}}</i>Shutdown Project</div></el-button>
          </div>
          <div class="powereddiv">
            <div class="div-block-14">
              <div class="text-block-9">Powered by </div>
              <a href="http://studioscreation.com" target="_blank" class="poweredlink w-inline-block">
                <div class="text-block-10">Studio S, Inc.</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">WebFont.load({  google: {    families: ["Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic","Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic","Dosis:regular,500,600,700,800"]  }});</script>

<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
<script src="../static/js/t2-cabinets-management-system.js" type="text/javascript"></script>
<script src="../static/js/xlsx-populate.min.js" type="text/javascript"></script>
<!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->

<script>
import { db, xp } from '../main'
import SignInButton from './SignInButton'
import AddDrawingForm from './AddDrawingForm'
import EditDrawingForm from './EditDrawingForm'
import NavSideBar from "./NavSideBar"
import MobileNav from "./MobileNav"
import { rebuildProject } from '../../static/js/appservice'
import { generateData, exportSheet, exportPackingPDF } from '../../static/js/statistics'

export default {
  name: 'ProjectSetting',
  props: ['user'],
  data () {
    return {
      currentProject: "NO_PROJECT_SELECTED",
      projectList: [],
      project: {},
      editingField: '',
      editingValue: '',
      unlockInput: '',
      menuNav: false
    }
  },
  firestore () {
    return {
      projectList: db.collection('project_list').where('version', '==', 2).orderBy('last_open_date','desc').limit(15),
      project: db.collection('project').doc('Project-1')
    }
  },
  created: function () {
    this.currentProject = this.$route.query.project
    // console.log('current project init, link to project')
    this.linkProject(this.currentProject)
  },
  watch: {
    $route: function () {
      this.currentProject = this.$route.query.project
    },
    currentProject: function () {
      // console.log('current project changed, link to new project')
      this.linkProject(this.currentProject)
      // this.$notify({
      //   title: 'Success',
      //   message: 'Switched to ' + this.currentProject,
      //   type: 'success',
      //   duration: 3000,
      //   offset: 64
      // })
    }
  },
  methods: {
    switchProject: function (projectId) {
      console.log('switch to =>', projectId)
      if (projectId !== ''){
        this.$router.push({
          path: 'settings',
          query: {
            project: projectId
          }
        })
      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    linkProject: function (projectId) {
      this.$bind('project', db.collection('project').doc(projectId))
    },
    confirmEdit: function () {
      let newData = {}
      newData[this.editingField] = this.editingValue
      db.collection('project_list').doc(this.project.id).update(newData)
      db.collection('project').doc(this.project.id).update(newData)
      this.editingField = ''
      this.editingValue = ''
      return "field changed"
    },
    startEdit: function (fieldName) {
      this.editingField = fieldName
      this.editingValue = this.project[fieldName]
    },
    cancelEdit: function () {
      this.editingField = ''
      this.editingValue = ''
    },
    shutdownProject: function () {
      if (this.unlockInput !== 'UNLOCK') {
        return
      }
      db.collection('project_list').doc(this.project.id).update({status: 'closed'})
      db.collection('project').doc(this.project.id).update({status: 'closed'})
      this.$router.push({
        path: '/'
      })
    }
  },
  components: {
    SignInButton,
    NavSideBar,
    MobileNav
  }
}

</script>

<style scoped>
.section-title {
  margin-top: 0.5em;
  margin-bottom: 1em;
  font-size: 1.8em;
}
.section-item {
  font-size: 1.2em;
  height: 64px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.item-tip {
  color: gray;
  margin-left: 16px;
}

.danger-title {
  margin-bottom: 1.4em;
  font-size: 1.8em;
  color: #f56c6c;
}
.danger-tag {
  width: 100%;
  height: auto;
  font-size: 16px;
  padding: 18px;
  overflow-wrap: break-word;
  border-radius: 5px;
  border: #f56c6c solid 1px;
  background-color: #fef1f1;
  color: #f56c6c;
}
.el-input__inner {
  color: #f56c6c;
  font-weight: bold;
  border-color: #f56c6c;
}
.el-input__inner :focus{
  border-color: #f56c6c;
}

.el-input__inner :hover{
  border-color: #f56c6c;
}

.material-icons {
  cursor: pointer;
}

@media screen and (max-width: 1024px){
    .section-item {
      text-align: center;
    }
    .section-title {
      text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectSetting.vue